import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnlock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.5 7.25C7.5 4.58009 9.42172 2.5 12 2.5C14.079 2.5 15.71 3.84093 16.2818 5.74211C16.4011 6.13877 16.8193 6.36363 17.216 6.24434C17.6127 6.12505 17.8375 5.70679 17.7182 5.31012C16.9709 2.82497 14.7919 1 12 1C8.50314 1 6 3.84478 6 7.25V9H5.5C4.11929 9 3 10.1193 3 11.5V19.5C3 20.8807 4.11929 22 5.5 22H18.5C19.8807 22 21 20.8807 21 19.5V11.5C21 10.1193 19.8807 9 18.5 9H7.5V7.25ZM4.5 11.5C4.5 10.9477 4.94772 10.5 5.5 10.5H18.5C19.0523 10.5 19.5 10.9477 19.5 11.5V19.5C19.5 20.0523 19.0523 20.5 18.5 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5V11.5Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgUnlock;
